import { render, staticRenderFns } from "./ModalTypeCard.vue?vue&type=template&id=090fbac4&"
import script from "./ModalTypeCard.vue?vue&type=script&lang=js&"
export * from "./ModalTypeCard.vue?vue&type=script&lang=js&"
import style0 from "./ModalTypeCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports